export default "__VITE_ASSET__ChbnFPcx__"